import styled from 'styled-components'

export const InnerContainer = styled.div`
  padding: 64px 0;
  text-align: center;
  display: flex;
  flex-flow: column;
  align-items: center;
`
